import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EGetNotificationsListActionTypes, TGetNotificationsListFailed } from './types';

export const getNotificationsListFailed: () => TGetNotificationsListFailed =
  actionGenerator<EGetNotificationsListActionTypes.Failed>(EGetNotificationsListActionTypes.Failed);
